import { Fragment } from 'react';

import { Error as FormError } from '@zola/zola-ui/src/components/Form/Error';

import { useFormState } from 'react-final-form';

import {
  RankedDateField,
  WeddingDateFormFields,
} from '~/components/common/form/WeddingDateField/types';

import { useErrorSpy } from './useErrorSpy';

/**
 * Custom error component for the wedding date field.  Our wedding date has
 * multiple fields (day/month/year) and the Form Validators set errors on the
 * field weddingDate (which does not exist in the form).  This looks at
 * all the possible wedding date fields and if one is in an error, displays
 * an error message for the combined field.
 */
export const DateError = ({
  field,
  forceVisible = false,
  className,
}: {
  field: undefined | RankedDateField;
  forceVisible?: boolean;
  className?: string;
}) => {
  const dayError = useErrorSpy('weddingDay', field);
  const monthError = useErrorSpy('weddingMonth', field);
  const yearError = useErrorSpy('weddingYear', field);
  const dateError = useErrorSpy('weddingDate', field);
  const error = [dayError, monthError, yearError, dateError].find(Boolean);

  const { submitFailed } = useFormState<WeddingDateFormFields>();
  const showError = submitFailed || forceVisible;

  if (error && showError) {
    return <FormError className={className} message={error} />;
  }
  return <Fragment />;
};
